import actions from '../action/cart'
import CONSTANT from '../constant/cart'
import localStorage from 'localStorage'
import _ from 'underscore'
import op from "object-path";
import cloneDeep from 'lodash.clonedeep';

export default {
  actions,
  state: {
    total: 0,
    fetch: false,
    list: {
      section: [],
      skuList: [],
    },
  },
  mutations: {
    [CONSTANT.CART_GET_TOTAL_SUCCESS](state, total) {
      // state.fetch = true
      state.total = total
      const count = localStorage.getItem(CONSTANT.CART_SET_TEMP_COUNT_BEFORE_LOGIN) || 0
      if (count > 0) {
        state.total += parseInt(count)
        localStorage.removeItem(CONSTANT.CART_SET_TEMP_COUNT_BEFORE_LOGIN)
      }
      return
    },
    [CONSTANT.CART_GET_TOTAL_ERROR](state, e) {
      return state.total = 0
    },
    [CONSTANT.CART_GET_TOTAL_ERROR_EMPTY](state, e) {
      return state.total = 0
    },
    [CONSTANT.CART_GET_SKU_SUCCESS](state, list) {
      return state.list = list
    },
    [CONSTANT.CART_GET_SKU_ERROR](state, e) {
      return
    },
    [CONSTANT.CART_GET_SKU_ERROR_EMPTY](state, e) {
      return
    },
    [CONSTANT.CART_DELETE_SKU_SUCCESS](state, options) {
      const skuList = options.skuIdList
      state.list.skuList = _.reject(state.list.skuList, (v) => {
        return _.some(skuList, (k) => {
          return k === v.skuId
        })
      })
    },
    [CONSTANT.CART_DELETE_SKU_ERROR](state, e) {
      return
    },
    [CONSTANT.CART_DELETE_SKU_ERROR_EMPTY](state, e) {
      return
    },
    selectCartSku(state, data) {
      // console.log(data);
      return state.list = data
    },
    selectSku(state, item) {
      // item.selected = !item.selected
      state.list.skulist = _.map(state.list.skuList, sku => {
        if(sku.skuId === item.skuId){
          sku.selected = !sku.selected
        }
        return sku
      })
    },
    supplierCheckAll(state, item) {
      //控制供应商全选,反选
      _.each(item.groups, v => {

        const selectedList = _.filter(v.product, v => {
          return v.selected;
        });
        if (v.product) {
          if (selectedList.length === v.product.length) {
            _.map(v.product, p => {
              state.list.skulist = _.map(state.list.skuList, sku => {
                if(sku.skuId === p.skuId){
                  sku.selected = false
                }
                return sku
              })
              // return (v.selected = false);
            });
          } else {
            _.map(v.product, p => {
              state.list.skulist = _.map(state.list.skuList, sku => {
                if(sku.skuId === p.skuId){
                  sku.selected = true
                }
                return sku
              })
              // return (v.selected = true);
            });
          }
        }
      });
    },
    touchAll(state) {
      // console.log(state.list.skuList)
      const selectedList = _.filter(state.list.skuList, (v) => {
        return v.selected
      });
      // console.log("selectedList", selectedList)
      if (selectedList.length === state.list.skuList.length) {
        _.map(state.list.skuList, (v) => {
          return v.selected = false
        })
        // console.log("state.list.skuList", state.list.skuList)
      } else {
        _.map(state.list.skuList, (v) => {
          return v.selected = true
        })
        // console.log("state.list.skuList", state.list.skuList)
      }
    },
    addSkuCount(state, item) {
      // item.count++
      //   state.total++
      //   return
      const cartList = state.list.skuList.slice()
      const array = []
      _.each(cartList, v => {
        if(v.skuId == item.skuId) {
          v.count++
        }
        array.push(v)
      })
      state.list.skuList = array
      state.total ++
    },
    subSkuCount(state, item) {
      // item.count--
      // state.total--
      // return
      const cartList = state.list.skuList.slice()
      const array = []
      _.each(cartList, v => {
        if(v.skuId == item.skuId) {
          v.count--
        }
        array.push(v)
      })
      state.list.skuList = array
      state.total --
    },
    inputSkuCount(state, {item, count}) {
      if(!count) {
        return
      }
      const cartList = state.list.skuList.slice()
      const array = []
      let number = 0
      _.each(cartList, v => {
        if(v.skuId == item.skuId) {
          v.count = count
        }
        array.push(v)
        number += v.count
      })
      state.list.skuList = array
      state.total = number
    },
    deleteSku(state, list) {
      const cartList = state.list.skuList
      // state.list = _.reject(cartList, (v) => {
      //   return _.contains(list, v.sku.skuId)
      // })
      const array = []
      let number = 0
      _.each(cartList, v => {
        if (!_.contains(list, v.skuId)) {
          array.push(v)
          number += v.count
        }
      })
      state.list.skuList = array
      state.total = number
    },
    addSkutoCartSuccess(state, options) {
      // state.total += options.skuList.length
      let number = 0
      _.each(options.skuList, (v) => {
        number += v.count
      })
      state.total += number
    },
    setLocalStorageList(state, list) {
      return state.list.skuList.push(list)
    },
    [CONSTANT.SKU_GET_DETAIL_BY_ID_SUCCESS](state, res) {
      const list = res
      return state.list = list
    },
    [CONSTANT.SKU_GET_DETAIL_BY_ID_ERROR](state, e) {
      return
    },
    [CONSTANT.SKU_GET_DETAIL_BY_ID_ERROR_EMPTY](state, e) {
      return
    },
    unloggedSetIn(state, count) {
      return state.total += count
    },
    [CONSTANT.CART_ADD_SKU_AGAIN](state, list) {
      return state.selectedSku = list
    }
    /*yeoman-template-point-1*/
  },
  getters: {
    validList: state => {
      const list = state.list;
      const ret = _.filter(list.skuList, v => {
        return op.get(v, "productStatus") === 1 && op.get(v, "inventory") > 0;
      });
      return ret;
    },
    sectionNew: (state, getters) => {
      const validList = cloneDeep(getters.validList);
      const section = cloneDeep(state.list.section);
      const obj = {};
      //根据供应商将产品分组
      _.each(validList, v => {
        if (obj[v.sectionId]) {
          obj[v.sectionId].push(v);
        } else {
          obj[v.sectionId] = [];
          obj[v.sectionId].push(v);
        }
      });
      //根据供应商包邮规则进一步分组
      const obj1 = {};
      _.each(obj, (v, key) => {
        if (!obj1[key]) {
          obj1[key] = [];
        }
        obj1[key] = v.reduce(function(acc, obj) {
          var key = obj["groupId"];
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {});
      });
      //将分组好的产品添加到section里对应的位置
      _.each(section, v => {
        _.each(obj1, (v1, key) => {
          if (v.sectionId == key) {
            _.each(v.groups, v2 => {
              _.each(v1, (v3, key1) => {
                if (v2.groupId == key1) {
                  if (!v2.product) {
                    v2.product = [];
                  }
                  v2.product = v3;
                }
              });
            });
            v1.priceSelectedDisabled = false
            // v1.priceSelectShow = false
          }
        });
      });
      //是否选择供应商
      _.each(obj, (v, key) => {
        // 判断是不是限购商品

        let num = key -1

        if(v[num]!== undefined && (v[num].purchaseLimit.limitedPurchaseCount !== 0 || v[num].purchaseLimit.minPurchaseCount > 1)){


          let justList = []
          let nojustList = []
          _.each(v, v1 => {
            if(v1.selectedDisabled === 0){
              justList.push(v1.skuId);
            }
          });
          _.each(v, v1 => {
            if(v1.selectedDisabled === 1){
              nojustList.push(v1.skuId);
            }
          });
          if(v.length === nojustList.length){
            let selectLisk = _.filter(v, v1 => {
              return v1.selected ;
            });
            if(selectLisk.length === nojustList.length){
              _.each(section, v2 => {
                if (v2.sectionId == key) {
                  v2.priceSelectedDisabled = true
                  v2.supplierAllSelect = true
                  // v2.priceSelectShow = true
                }
              });
            }else{
              _.each(section, v2 => {
                if (v2.sectionId == key) {
                  v2.priceSelectedDisabled = true
                  v2.supplierAllSelect = false
                }
              });
            }
          }else{
            const selectedList = _.filter(v, v1 => {
              return v1.selected && v1.selectedDisabled === 0;
            });
            if (selectedList.length === justList.length) {
              _.each(section, v2 => {
                if (v2.sectionId == key) {
                  v2.supplierAllSelect = true
                }
              });
            } else {
              _.each(section, v2 => {
                if (v2.sectionId == key) {
                  v2.supplierAllSelect = false
                }
              });
            }
          }

        }else{
          const selectedList = _.filter(v, v1 => {
            return v1.selected;
          });
          if (selectedList.length === v.length) {
            _.each(section, v2 => {
              if (v2.sectionId == key) {
                v2.supplierAllSelect = true
              }
            });
          } else {
            _.each(section, v2 => {
              if (v2.sectionId == key) {
                v2.supplierAllSelect = false
              }
            });
          }
        }


      })
      //是否显示包邮规则
      _.each(section, s => {
        _.each(s.groups, g => {
          if (!_.has(g, "product")) {
            g.isGroup = false
          }else {
            g.isGroup = true
          }
        })
      })
      //是否显示供应商
      _.each(section, s => {
        let judge = _.every(s.groups, v => {
          return v.isGroup
        })
        if (judge) {
          s.isSection = true
        } else {
          s.isSection = false
        }
      })
      // console.log(8, section);
      return section;
    },
  },

}
